


























import { defineComponent } from "@vue/composition-api";
import { GroupWithCount } from "@/hooks/useGroups";
import ListItem from "@/components/ListItem";

export default defineComponent({
  name: "GroupList",
  components: { ListItem },
  props: {
    groups: { type: Array as () => GroupWithCount[] },
    itemClass: { type: String },
    groupLink: { type: Boolean, default: false },
  },
  methods: {
    getRouterLink(item: GroupWithCount) {
      return this.$route.name === "manageGroups"
        ? { name: "manageGroupUsers", params: { groupId: item.id } }
        : undefined;
    },
    getPlurMemberCount(item: GroupWithCount) {
      if (item.memberCount) {
        return item.memberCount === 1
          ? this.$t("{0} person", [item.memberCount])
          : this.$t("{0} people", [item.memberCount]);
      } else {
        return item.memberIds.length === 1
          ? this.$t("{0} person", [item.memberIds.length])
          : this.$t("{0} people", [item.memberIds.length]);
      }
    },
  },
});
